import React, {
  ChangeEvent,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useSentRequestSupportMutation } from '../../apis/mlkApi/mlk.api.hooks';
import { Button } from '../../components/Button/Button';
import { BaseLayout } from '../../components/Layout/Layout';
import { ModalRef } from '../../components/Modal/Modal';
import { useBack } from '../../hooks/useBack';
import { useLanguage } from '../../locale/useLanguage';
import { Routes } from '../../routes/types';
import { OrderHelpModal } from './componets/orderHelpModal';

import './OrderHelpView.css';

type OrderHelpRouteParams =
  | {
      orderId: number | undefined;
      purchaseId: number | undefined;
    }
  | undefined;

type OrderHelpViewProps = {};

export const OrderHelpView: React.FC<OrderHelpViewProps> = () => {
  const [t] = useLanguage();
  const back = useBack();
  const location = useLocation<OrderHelpRouteParams>();
  const history = useHistory();
  const [sendRequest] = useSentRequestSupportMutation();
  const askSupportModalRef = useRef<ModalRef>(null);

  const [text, setText] = useState('');

  useEffect(() => {
    if (!location.state?.orderId || !location.state?.purchaseId) {
      history.replace(Routes.Home);
    }
  }, [history, location.state?.orderId, location.state?.purchaseId]);

  const onTextChange = useCallback((e: ChangeEvent<HTMLTextAreaElement>) => {
    setText(e.target.value);
  }, []);

  const sendHelp = useCallback(async () => {
    if (
      location.state?.orderId !== undefined &&
      location.state?.purchaseId !== undefined
    )
      await sendRequest({
        orderId: location.state.orderId,
        purchaseId: location.state.purchaseId,
        message: text,
      }).unwrap();
    askSupportModalRef.current?.openModal();
  }, [location.state, sendRequest, text]);

  return (
    <BaseLayout
      hasBack
      onBackClick={back}
      hasViewportHeight
      title={t('pageTitles.orderHelp')}
    >
      <div className="order-help--container">
        <h2 className="subtitle">{t('orderHelp.title')}</h2>
        <p className="paragraph">{t('orderHelp.description')}</p>
        <textarea
          placeholder={t('orderHelp.helpPlaceholder')}
          className="order-help--textarea"
          onChange={onTextChange}
          value={text}
        />
        <Button
          isDisabled={!text}
          onClick={sendHelp}
          isPrimary
          label={t('orderHelp.sendRequest')}
        />
      </div>
      <OrderHelpModal ref={askSupportModalRef} />
    </BaseLayout>
  );
};
